import React from 'react';
import {
    initialState,
    IPublicationsState,
    PublicationsActionDispatcher,
    publicationsReducer,
} from './publications.state';
import { PublicationForm, PublicationStatusEnum } from '../../../types/index';

export const defaultArticles: IPublicationsState = initialState;

export const PublicationsContext = React.createContext(defaultArticles);
export const PublicationsDispatchContext = React.createContext<PublicationsActionDispatcher | undefined>(undefined);

export const basePublicationInfo: PublicationForm = {
    title: 'Untitled',
    docTypeId: '',
    pubVersion: 1,
    keywords: [],
    dtcCodes: [],
    toolNumbers: [],
    description: '',
    status: PublicationStatusEnum.Draft,
    publicationType: { label: '', code: '', id: '', description: '' },
    docCode: '',
    visibilityLevel: { label: '', value: '' },
    url: '',
    contentFile: {
        fileName: '',
        fileType: '',
        createdDate: '',
        createdTimestamp: '',
        createdBy: '',
    },
    createdDate: new Date(),
    associatePublicationChange: false,
    associateVehicleChange: false,
    fileUploadChange: false,
    tagsChange: false,
};

export const PublicationsProvider: React.FC<React.PropsWithChildren<any>> = ({ children }) => {
    const [state, dispatch] = React.useReducer(publicationsReducer, initialState);

    return (
        <PublicationsContext.Provider value={state}>
            <PublicationsDispatchContext.Provider value={dispatch}>{children}</PublicationsDispatchContext.Provider>
        </PublicationsContext.Provider>
    );
};
